import BankAccountDetails from './BankAccountDetails.vue'
import PayerDetails from './PayerDetails.vue'
import PaymentPlan from './PaymentPlan.vue'
import PayerHistory from './PayerHistory.vue'
import PayerAlerts from './PayerAlerts.vue'
import PayerNotes from './PayerNotes.vue'
import PayerHistoryNotes from './PayerHistoryNotes.vue'
export default { BankAccountDetails, PayerDetails, PaymentPlan, PayerHistory, PayerAlerts, PayerNotes, PayerHistoryNotes }
